var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 5.5C7.75 5.72981 7.70474 5.95738 7.61679 6.1697C7.52884 6.38202 7.39994 6.57493 7.23744 6.73744C7.07493 6.89994 6.88202 7.02884 6.6697 7.11679C6.45738 7.20474 6.22981 7.25 6 7.25C5.77019 7.25 5.54262 7.20474 5.3303 7.11679C5.11798 7.02884 4.92507 6.89994 4.76256 6.73744C4.60006 6.57493 4.47116 6.38202 4.38321 6.1697C4.29526 5.95738 4.25 5.72981 4.25 5.5C4.25 5.03587 4.43437 4.59075 4.76256 4.26256C5.09075 3.93437 5.53587 3.75 6 3.75C6.46413 3.75 6.90925 3.93437 7.23744 4.26256C7.56563 4.59075 7.75 5.03587 7.75 5.5Z",
    stroke: "#909090",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C8.435 1 10.5 3.0165 10.5 5.463C10.5 7.948 8.4015 9.6925 6.4635 10.878C6.322 10.9576 6.16237 10.9995 6 10.9995C5.83763 10.9995 5.678 10.9576 5.5365 10.878C3.6015 9.6815 1.5 7.9575 1.5 5.4635C1.5 3.0165 3.565 1 6 1Z",
    stroke: "#909090",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.235245e67f68ce1dfc9dfb5491b9f94f.svg";
export { ForwardRef as ReactComponent };